import { AuthenticationClient } from '../authentication/client';
import { FILTERS_URL } from './utils';
import axios from 'axios';
import { logger } from '../logging';

export const markFilterViewed = async (filterId: string, basePath = FILTERS_URL) => {
  try {
    const token = await AuthenticationClient.getInstance().getAccessToken();

    await axios.patch(
      `/v1/filters/${filterId}`,
      { viewed: true },
      {
        baseURL: basePath,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (e) {
    logger.error(e);
    throw e;
  }
};
